// extracted by mini-css-extract-plugin
export default {"page-loading-wrapper":"styles_page-loading-wrapper__Yk439"};